export const isExemptionApplication = (code?: string | number) =>
  code === '35e521d1-779d-4a68-b1f2-6e243853d3ea' ||
  code === 'ff950b41-bd38-4fb9-9843-8298049f0aec' ||
  code === '592be66f-0c45-4007-bca2-e5cd0a597588';
export const isBorderResident = (code?: string | number) =>
  code === '5b2f4e04-03fb-4880-a2a3-387a5e1601da';
export const isGreenZoneResident = (code?: string | number) =>
  code === '610ee05f-bfc9-43c9-9928-5d0f71cf7eb4';
export const isOrangeZoneResident = (code?: string | number) =>
  code === 'abb90005-85f9-46fe-bb94-b4abcaeb4959';
export const isTransitingThroughVic = (code?: string | number) =>
  code === '1ed7c25b-54dd-419c-9a46-c0f0cbac9960';
export const isVictorianReturningFromRedZone = (code?: string | number) =>
  code === '8ef57986-8fd2-487e-b07b-78808a89d53b';
export const isCrossBorderResident = (code?: string | number) =>
  code === '48746a81-4735-43a3-9274-bc3ac5a6dd0f';
export const isHotelQuarantinePermit = (code?: string | number) =>
  code === '042ea183-0a88-4682-8245-334844f257bb';
export const isReturnExemption = (code?: string | number) =>
  code === '79fb6d8d-ffbc-427a-8405-dca063149e4a';
export const isFullVaxERZVictorian = (code?: string | number) =>
  code === 'c438220e-f5e2-46c5-9fb3-ee62ef514ba1';
export const isRedZoneResident = (code?: string | number) =>
  code === 'f01e6176-2104-46d4-8ce3-ec7180423e08';
export const isSpecifiedWorker = (code?: string | number) =>
  code === 'bb05d9ca-410d-4719-a306-cfe5b31a25ad' ||
  code === '11185bbf-8bd8-417e-89ed-dc15ed7d4298';
export const isInternationalArrival = (code?: string | number) =>
  code === '9ae90fb8-a0dc-4ad1-a811-b01ac1661150';
